/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Medicine15Inputs */

const en__field__enum_primarystudyinterest_study_medicine15 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Medicine15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medicine`)
};

const de__field__enum_primarystudyinterest_study_medicine15 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Medicine15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medizin`)
};

/**
* | output |
* | --- |
* | "Medicine" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Medicine15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_medicine15 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Medicine15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Medicine15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_medicine15(inputs)
	return de__field__enum_primarystudyinterest_study_medicine15(inputs)
});
export { _field__enum_primarystudyinterest_study_medicine15 as "_field__enum_primaryStudyInterest_STUDY_MEDICINE" }